/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const checkout = {
  checkout: {
    backToCart: 'Volver a la cesta',
  },
  checkoutProgress: {
    label: 'Progreso del proceso de pago',
    deliveryAddress: 'Dirección de envío',
    deliveryMode: 'Modo de entrega',
    paymentDetails: 'Pago',
    reviewOrder: 'Revisión',
  },
  checkoutAddress: {
    shippingAddress: 'Dirección de envío',
    selectYourDeliveryAddress: 'Seleccione su dirección de entrega',
    defaultDeliveryAddress: 'Dirección de entrega predeterminada',
    addNewAddress: 'Agregar nueva dirección',
    shipToThisAddress: 'Enviar a esta dirección',
    deliveryAddressSelected: 'Dirección de entrega seleccionada',
  },
  checkoutMode: {
    deliveryMethod: 'Método de entrega',
    standardDelivery: 'Entrega estándar',
    premiumDelivery: 'Entrega Premium',
    deliveryEntries: 'Artículos a enviar',
  },
  checkoutReview: {
    review: 'Revisión',
    orderItems: 'Artículos de pedido',
    confirmThatRead: 'Confirmo que he leído y estoy de acuerdo con el',
    placeOrder: 'Realizar pedido',
    termsAndConditions: 'Términos y condiciones',
    editDeliveryAddressDetails:
      'Edite los detalles de la dirección de entrega, abra la página Dirección de entrega',
    editPagoDetails: 'Edita los detalles del pago y abre la página Detalles de Pago',
    editPagoType: 'Edita el método de pago, abre la página Método de pago',
    editDeliveryMode: 'Edita el modo de entrega, abre la página Modo de entrega',
    orderInProcess: 'El pedido está en proceso. Espera.',
  },
  checkoutOrderConfirmation: {
    confirmationOfOrder: 'Confirmación del pedido:',
    thankYou: '¡Gracias por su orden!',
    invoiceHasBeenSentByEmail:
      'Se ha enviado una confirmación de pedido por correo electrónico. Deberías recibirlo pronto.',
    orderItems: 'Artículos de pedido',
    orderPlacedSuccessfully: 'Pedido realizado con éxito',
    createAccount: 'Create an account?',
    createAccountForNext:
      'Crea una cuenta para <{{email}}> para un pago más rápido en tu próxima visita.',
  },
};
